import './components/ga-events';            //should be on top of each page's JS file
import "./components/swipe-for-more";       // should be as soon as possible
import "./parts/navigation";
import "./parts/keyboard-navigation";
import "./parts/accept-cookies";
import "./parts/ftc-disclosure";
import "./components/accessibility-widget";
import "./components/js-links";
import "./widgets/quick-nav";
import "./components/gallery";
import "./components/show-hide-on-visible-position";
import "./components/scroll-top-btn";
import "./components/accordion-pw";
import "./components/svg";

import tooltips from './components/tooltips';
import ExitPopup from "./components/exit-popup";
import { shouldInitCarousel } from './components/carousel-viewport';

import $ from "cash-dom";

import prequalState from './parts/ppc/prequalify-modal/PrequalState';

prequalState.isPrequalShown = false;

$(function () {
    ExitPopup.init();
    tooltips.initOnce();

    const topLoansCarousel = document.querySelector('#top_loans_carousel.carousel');
    const topLoansPpcCarousel = document.querySelector('#top_loans_carousel_2.carousel');
    const categoriesCarousel = document.querySelector('#categories_carousel.carousel');
    const shouldInitTopLoansCarousel = shouldInitCarousel(topLoansCarousel);
    const shouldInitTopLoansPpcCarousel = shouldInitCarousel(topLoansPpcCarousel);

    if (shouldInitTopLoansCarousel || shouldInitTopLoansPpcCarousel || categoriesCarousel) {
        import('./components/Carousel').then(({ default: Carousel }) => {
            if (shouldInitTopLoansCarousel) {
                Carousel.initAll('#top_loans_carousel.carousel');
            }

            if (shouldInitTopLoansPpcCarousel) {
                Carousel.initAll('#top_loans_carousel_2.carousel');
            }

            if (categoriesCarousel) {
                Carousel.initAll('#categories_carousel.carousel');
            }
        });
    }
});
